import { useGetApplication } from 'app/hooks';
import httpApiApplication from 'app/http/httpApiApplication';
import { type Taxpayer } from 'app/modules/Reports/TaxReturnList/types';
import { type ResponseValues } from 'axios-hooks';

import type Paginated from '../../../core/paginable';
import { useCatalogValueList } from '../../configuration/catalogs/hooks/useCatalogValueList';
import { catalogName } from '../../configuration/catalogs/models/Catalog';

import { type TaxPeriodicity } from './TaxPeriodicity/types';
import { BaseUrlTax, BaseUrlTaxpayer, BaseUrlTaxPeriodicity } from './http';
import { type Tax, type TaxPayerTax } from './types';

export const useTax: (id: string) => ResponseValues<Tax, any, any> = (id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<Tax>>({
    url: BaseUrlTax,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [tax] = data?.data || [];

  return { loading, data: tax, error, response } as any;
};

export const useTaxpayer: (id: string) => ResponseValues<Taxpayer, any, any> = (id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<Taxpayer>>({
    url: BaseUrlTaxpayer + '/paging',
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [taxpayer] = data?.data || [];

  return { loading, data: taxpayer, error, response } as any;
};

// export const useTaxRate: (taxId: string, id: string) => ResponseValues<TaxRate, any, any> = (
//   taxId: string,
//   id: string
// ) => {
//   const [{ data, loading, error, response }] = useGetApplication<Paginated<Tax>>({
//     url: `${BaseUrlTax}/${taxId}${BaseUrlTaxRates}`,
//     params: {
//       id,
//       page: 1,
//       pageSize: 1
//     }
//   });
//
//   const [tax] = data?.data || [];
//
//   return { loading, data: tax, error, response };
// };

export const useTaxPeriodicity: (
  taxId: string,
  id: string
) => ResponseValues<TaxPeriodicity, any, any> = (taxId: string, id: string) => {
  const [{ data, loading, error, response }] = useGetApplication<Paginated<TaxPeriodicity>>({
    url: `${BaseUrlTax}/${taxId}${BaseUrlTaxPeriodicity}`,
    params: {
      id,
      page: 1,
      pageSize: 1
    }
  });

  const [taxPeriodicity] = data?.data || [];

  return { loading, data: taxPeriodicity, error, response } as any;
};

export const usePeriodicityTypes = () => {
  return useCatalogValueList(catalogName.periodicityType);
};

export const useRateTypes = () => {
  return useCatalogValueList(catalogName.rateType);
};

export const useGetAllTaxes: (loadMode?: boolean) => ResponseValues<Array<Tax>, any, any> = (
  loadMode = true
) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<Tax>>(
    {
      url: `${BaseUrlTax}/all`,
      params: undefined
    },
    loadMode
  );

  return { loading, data: data, error, response };
};

export const useGetAllTaxesTax: (
  loadMode?: boolean
) => ResponseValues<Array<TaxPayerTax>, any, any> = (loadMode = true) => {
  const [{ data, loading, error, response }] = useGetApplication<Array<TaxPayerTax>>(
    {
      url: `${BaseUrlTaxpayer}/tax`,
      params: undefined
    },
    loadMode
  );

  return { loading, data: data, error, response };
};

export const GetAllTaxesFrom: (tin: string) => Promise<Array<TaxPayerTax>> = async (
  tin: string
) => {
  return await httpApiApplication.get<Array<TaxPayerTax>>(`${BaseUrlTaxpayer}/${tin}/tax`);
};
